import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseModalComponent } from '../../../../../../../../models/base/base-modal.component';
import { AddProductGroupsToBrandModalViewModel } from './add-product-groups-to-brand-modal-view-model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-product-groups-to-brand-modal',
  standalone: false,
  templateUrl: './add-product-groups-to-brand-modal.component.html',
  styleUrl: './add-product-groups-to-brand-modal.component.scss',
  providers: [AddProductGroupsToBrandModalViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddProductGroupsToBrandModalComponent extends BaseModalComponent {
  constructor(
    public viewModel: AddProductGroupsToBrandModalViewModel,
    private activeModal: NgbActiveModal
  ) {
    super(activeModal);
  }

  stickyCollectionKey: string = 'add-product-groups-to-brand-modal';
  stickyZ: number = 1;
}
